import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../Header';
import Footer from '../Footer';
import '../../styles/blog.css';

const BlogLayout = ({ 
  children, 
  title = 'Blog', 
  description = 'TukeWIN Blog - Insights about technology, development, and innovation',
  keywords = 'blog, technology, development, programming, web development',
  isMenuOpen,
  setIsMenuOpen 
}) => {
  return (
    <>
      <Helmet>
        <title>{title} | TukeWIN</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta property="og:title" content={`${title} | TukeWIN`} />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={`${title} | TukeWIN`} />
        <meta name="twitter:description" content={description} />
      </Helmet>
      
      <div className="min-h-screen bg-slate-900 text-white">
        <Header isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
        
        <main className="blog-container">
          {children}
        </main>
        
        <Footer />
      </div>
    </>
  );
};

export default BlogLayout;